import { Directive, Input, ElementRef, Renderer } from '@angular/core';



@Directive({
  selector: '[appSaNumberColumnSort]'
})
export class SaNumberColumnSortDirective {

  @Input() datanumber: any[];
  @Input('sortKeynumber') key: any;
  private toggleSort: boolean            = false;

  constructor (private el: ElementRef, private renderer: Renderer) {
  }

  ngOnInit () {
    this.renderer.listen(this.el.nativeElement, 'click', (event) => {
      let parentNode = this.el.nativeElement.parentNode;
      let children   = parentNode.children;

      if (this.datanumber && this.key) {
        let sortedData: any = this.sortArray();
      }
      this.toggleSort = !this.toggleSort;
    })
  }

  sortArray (): Array<any> {
    let tempArray: Array<any> = this.datanumber;
    tempArray.sort((a, b) => {
      let aKey = a[this.key];
        let str1  = a[this.key];
        let str2  = b[this.key];
        if (this.toggleSort) {
          if (str1 < str2) {
            return -1;
          }
          if (str1 > str2) {
            return 1;
          }
        }
        else {
          if (str1 > str2) {
            return -1;
          }
          if (str1 < str2) {
            return 1;
          }
        }
      return 0;
    });
    return tempArray;
  }

}
